import React from 'react';
import { Card } from 'antd';

export default class SFCard extends React.Component {
    render() {
        return (
            <Card
                bordered={this.props.bordered || false}
                className={this.props.borderShadows && `${this.props.className} border-shadows`}
                {...this.props}
            >
                {this.props.children}
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/SFCard.js